// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__bIo4F","dropdown":"Avatar_dropdown__8ZKc9","logout":"Avatar_logout__jaXmI","divider":"Avatar_divider__dVb53"};